// extracted by mini-css-extract-plugin
module.exports = {"crossFade":"ImageSwitcher_crossFade__7_SC0","hasHoverImage":"ImageSwitcher_hasHoverImage__bRnYF"};